import React, { useState } from "react";
import { Grid, Typography, Divider, Box } from "@mui/material";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import _ from "lodash";
import { captionStyle, paraStyle } from "../../screens/JaldiLab/Chapters/ChapterList";
import useCustomLogic from "../../Hooks/UseCustomLogic";
import ChapterDialog from "../Dialog/ChapterDialog";

const CaptionWithBorders2 = ({
    image = "" || [],
    isZoom = true,
    caption = "",
    creditLabel = "",
    imageCredit = "",
    height = "auto",
    zoomImgStyle = "",
    imgStyle = {},
    onClick = () => { },
    captionPadding = "",
    divHeight = "",
    imageDescription = "",
}) => {
    const [isDialog, setIsDialog] = useState(false);
    const imageWidth = image.length > 1 ? `${100 / image.length}%` : "100%";
    const isCaption = _.startsWith(caption, "Figure");
    const { isXs, isSm } = useCustomLogic();
    const isResponsived = (isXs && isSm)

    const handleOpenDialog = () => {
        setIsDialog(true);
    };

    const handleCloseDialog = () => {
        setIsDialog(false);
    };

    return (
        <div style={{ padding: "20px 10px" }}>
            <div
                style={{
                    display: (isResponsived && image.length == 1) ? "" : (isXs && image.length > 1) ? "block" : "flex",
                    // display: isResponsived ? "block" : "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "20px",
                    height: divHeight
                }}
            >
                {image &&
                    image.map((elem) => {
                        return (
                            <Zoom>
                                <div
                                    style={{
                                        height: !isResponsived && (elem?.height || "100%"),
                                        // height: elem.height || "100%",
                                        padding: !isResponsived && "20px 0px",
                                    }}
                                >
                                    <img
                                        src={elem.imgSr}
                                        alt="zoom_img"
                                        style={{
                                            width: elem?.zoomImgWidth ? elem.zoomImgWidth : (zoomImgStyle?.zoomImgWidth || "100%"),
                                            height: !isResponsived && (zoomImgStyle?.zoomImgHeight || "100%"),
                                            objectFit: !isResponsived && (zoomImgStyle?.objectFit || "contain"),
                                        }}
                                    />
                                </div>
                            </Zoom>
                        );
                    })}
            </div>

            {caption && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: captionPadding || "10px",
                    }}
                >
                    <Divider style={{ flexGrow: 1, borderBottom: "1px solid red" }} />
                    <div style={{ textAlign: "center" }}>
                        <Typography
                            style={captionStyle}
                        >
                            {caption}
                        </Typography>
                        <Box display={isResponsived ? "inline-block" : "flex"} justifyContent={"center"}>
                            {imageCredit && (
                                <span
                                    style={{
                                        fontFamily: "lato",
                                        fontWeight: 500,
                                        fontStyle: "italic",
                                        fontSize: "12px",
                                        color: "#1D1D1D",
                                    }}
                                >
                                    {creditLabel}:
                                    <span
                                        style={{
                                            fontFamily: "lato",
                                            fontWeight: 500,
                                            fontStyle: "italic",
                                            color: "red",
                                            paddingLeft: "4px",
                                        }}
                                    >
                                        {imageCredit}
                                    </span>
                                </span>
                            )}
                            <button
                                type="button"
                                style={{
                                    fontSize: "12px",
                                    fontFamily: "lato",
                                    fontWeight: 500,
                                    fontStyle: "italic",
                                    color: "red",
                                    paddingLeft: "4px",
                                    cursor: "pointer",
                                    border: 0,
                                    background: "transparent",
                                }}
                                onClick={() => handleOpenDialog()}
                            >
                                {imageCredit && "|"} {isCaption ? "Figure" : "Image"} Description
                            </button>
                        </Box>
                    </div>
                    <Divider style={{ flexGrow: 1, borderBottom: "1px solid red" }} />
                </div>
            )
            }

            {
                isDialog && (
                    <ChapterDialog
                        open={isDialog}
                        onCloseDialog={handleCloseDialog}
                        title={`${isCaption ? "Figure" : "Image"} Description`}
                        no={2}
                    >
                        <Grid
                            container
                            mt={3}
                            flexDirection={"column"}
                            sx={{ margin: "0px 20px" }}
                        >
                            <Typography
                                variant="h3"
                            >
                                {imageDescription?.title}
                            </Typography>
                            <Box mt={1}>
                                <p style={paraStyle}>
                                    {imageDescription?.para1}
                                </p>
                                {imageDescription?.items}
                            </Box>
                        </Grid>
                    </ChapterDialog>
                )
            }
        </div>
    );
};

export default CaptionWithBorders2;
